import React, { useState, useEffect, useRef, useMemo } from 'react'
import Layout from 'Layout'
import './MyOrderDetail.scss'
import AccountMenu from 'components/User/AccountMenu'
import MyOrder from 'components/User/MyOrder'
import MyOrderDetailInfo from 'components/User/MyOrderDetailInfo'
import MyOrderDetailListProduct from 'components/User/MyOrderDetailListProduct'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from 'api/Order'

interface OrderDetailData {
  id: number;
  customer_id: number;
  code: string;
  total: number;
  total_discount: number | null;
  fullname: string;
  phone: string;
  address: string;
  created_at?: string; // Add if available in API or infer
  status?: number; // Add if available in API or infer
  history: [
    {
      id: number;
      order_id: number;
      created_by: number;
      status: string;
      note: string;
      created_at: string;
      updated_at: string;
    }
  ]
  order_product: {
    id: number;
    order_id: number;
    discount_price: number | null;
    status: number | null;
    quantity_product: number;
    name_product: string;
    slug_product: string;
    avatar_product: string;
    price_product: number;
  }[];
}

const WishlistPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [orderDetail, setOrderDetail] = useState<OrderDetailData | null>(null);

  useEffect(() => {
    document.body.classList.add("NoneHeaderFooter");

    const fetchOrderDetail = async () => {
      if (slug) {
        const response = await getOrderDetail(slug);
        if (response && response.status) {
          setOrderDetail(response.data);
        }
      }
    };

    fetchOrderDetail();

    return () => {
      document.body.classList.remove("NoneHeaderFooter");
    };
  }, [slug]);

  if (!orderDetail) {
    return (
        <Layout>
            <div className='style_container__3o3Ct my-order-detail-page'>
                Loading...
            </div>
        </Layout>
    )
  }

  return (
    <Layout>
      <div className='style_container__3o3Ct my-order-detail-page'>
        <div className="styles_wrapDirect__RrlO8 MuiBox-root css-0 hidden-1199">
          <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
            <ol className="MuiBreadcrumbs-ol">
              <li className="MuiBreadcrumbs-li">
                <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
              </li>
              <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                </svg>
              </li>
              <li className="MuiBreadcrumbs-li">
                <a className="styles_item_breadcrumb__eYGFd" href="/my-order">Danh sách đơn hàng</a>
              </li>
              <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                </svg>
              </li>
              <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Chi tiết đơn hàng #{orderDetail.code}</span>
              </li>
            </ol>
          </nav>
        </div>
        <div className="jss3">
          <AccountMenu />
          <div className="styles_full_width__2R9Yf">
            <div className="MuiGrid-root styles_comeback__YRafY MuiGrid-item MuiGrid-grid-xs-12"><a href="/my-order">&lt;&lt; Quay lại đơn hàng của tôi</a></div>
            <MyOrderDetailInfo orderDetail={orderDetail} />
            <MyOrderDetailListProduct products={orderDetail.order_product} total={orderDetail.total_discount ?? orderDetail.total} />
            <div className="MuiGrid-root styles_comeback__YRafY MuiGrid-item MuiGrid-grid-xs-12" style={{ marginTop: "25px" }}><a href="/my-order">&lt;&lt; Quay lại đơn hàng của tôi</a></div>
          </div>
        </div>
      </div>
    </Layout >
  )
}

export default WishlistPage
